import { createContext, useContext } from 'react';

export interface WalletState {
  readonly balanceCents: number;
  readonly currency: string;
  /**
   * On-hold amount, in cents (MYP-54). Fixture only — neither the legacy 账号余额与充值 screenshot
   * nor any of the ~40 vendor endpoint titles surfaces this field. Flagged here rather than built
   * as if verified, pending a real source.
   */
  readonly onHoldCents: number;
}

export const WalletContext = createContext<WalletState | null>(null);

export function useWallet(): WalletState {
  const value = useContext(WalletContext);
  if (!value) throw new Error('useWallet must be used inside WalletProvider');
  return value;
}
